import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Input,
  Row,
  Col,
  CardTitle,
} from "reactstrap";
import {
  addUserComment,
  getAllCommentListById,
} from "../../../service/user-verification-service";
import moment from "moment";
import Loading from "../../loader/loader.js";

const Comments = ({ id = null }) => {
  const [comment, setComment] = useState(null);
  const [commentList, setCommentList] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);

  useEffect(() => {
    if (id) {
      getCommentListById(id);
    }
  }, []);

  const getCommentListById = (id) => {
    getAllCommentListById(id)
      .then((getAllCommentListByIdRes) => {
        console.log({ getAllCommentListByIdRes });
        setCommentList(
          (getAllCommentListByIdRes &&
            getAllCommentListByIdRes.data.commments) ||
            []
        );
      })
      .catch((getAllCommentListByIdErr) => {
        setCommentList([]);
        console.log(getAllCommentListByIdErr);
      });
    console.log(commentList);
  };

  const postComment = () => {
    setDataLoading(true);
    console.log("post comment clicked", comment); // TODO - NEED TO CHECK REQUEST HERE...PENDING
    addUserComment({ id, comment })
      .then((addUserCommentRes) => {
        setDataLoading(false);
        console.log({ addUserCommentRes, comment });
        //postcomments-what ?
        setComment("");
        getCommentListById(id);
      })
      .catch((addUserCommentErr) => {
        setComment("");
        console.log(addUserCommentErr);
        setDataLoading(false);
      });
  };

  return (
    <Card style={{ paddingBottom: 20 }}>
      <CardBody>
        <CardTitle
          className="mb-3"
          tag="h1"
          className="user-verification-header"
        >
          Comments
        </CardTitle>
        {dataLoading ? (
          <div
            style={{ maxHeight: 400, overflowY: "scroll", textAlign: "center" }}
          >
            <Loading />
          </div>
        ) : (
          <div style={{ maxHeight: 400, overflowY: "scroll" }}>
            {commentList.map((com) => {
              return (
                <Card style={{ marginBottom: 10, padding: 5 }}>
                  <div>
                    <small>
                      <b>{com.commentBy}</b>{" "}
                      <span style={{ fontSize: 14, color: "#4a5762" }}>
                        {moment(com.createdDate).format("DD-MM-YY h:mm:ss a")}
                      </span>
                    </small>
                  </div>
                  <div style={{ fontSize: 14 }}>{com.comment}</div>
                </Card>
              );
            })}
          </div>
        )}

        <Row style={{ marginTop: "20px" }}>
          <Col lg="9">
            <FormGroup>
              <Input
                id="commentInput"
                value={comment}
                onChange={(e) => {
                  setComment(e.target.value || null);
                }}
                placeholder="Write a comment"
                type="text"
              />
            </FormGroup>
          </Col>
          <Col lg="2">
            <Button
              color="primary"
              type="button"
              disabled={((comment && comment.length > 0) && !dataLoading) ? false : true}
              onClick={() => {
                postComment();
              }}
            >
              Post
            </Button>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default Comments;
